export const CREATE_CUSTOM_CHART_MOCK = {
  data: {
    createCustomChart: {
      id: "0-custom-chart",
    },
  },
};
